import React from 'react';
import Label from '../ui/forms/Label';
import BoxedNumberInput from '../shared/forms/BoxedNumberInput';
import BoxedInput from '../shared/forms/BoxedInput';
import DoubleWrap from '../ui/forms/DoubleWrap';
import InputWrap from '../ui/forms/InputWrap';
import BoxedSelect from '../shared/forms/BoxedSelect';
import FormTextWrap from '../ui/forms/FormTextWrap';
import Button from '../ui/Button';
import FormWrapper from '../ui/forms/FormWrapper';
import ButtonWrap from '../ui/forms/ButtonWrap';
import BackButton from '../ui/BackButton';


const ContactDetails = (props) => {
        const 
        {   
            state,
            applicantDetails
        } = props;

        return (
            <>
                <div data-test-id = 'contactDetails'>
                    <FormTextWrap>
                        Please verify and update your information.
                    </FormTextWrap>
                    <FormWrapper>
                        <BoxedNumberInput
                            type="tel"
                            value={state.stage5_mobile}
                            maxLength="8"
                            decimalSeparator={false}
                            onChange={props.onChange}
                            onKeyDown={props.onKeyDown}
                            label="Mobile Number"
                            prefix="65"
                            name="stage5_mobile"
                            error={state.stage5_mobile_error}
                            warning={state.stage5_mobile!==state.stage5_mobile_bms}
                            warningMsg ="Mobile is different from the one provided earlier. Please confirm."
                            />
                        <BoxedInput
                            type="text"
                            onChange={props.onChange}
                            onKeyDown={props.onKeyDown}
                            maxLength="320"
                            label="Email Address"
                            name="stage5_email"
                            value={state.stage5_email}
                            error={state.stage5_email_error} 
                            warning={state.stage5_email.toUpperCase()!==state.stage5_email_bms.toUpperCase()}
                            warningMsg ="Email is different from the one provided earlier. Please confirm."
                            />
                        <DoubleWrap>
                            <BoxedInput 
                                disabled={applicantDetails.residentialAddress.source === '1'}
                                type="text"
                                maxLength="10"
                                onChange={props.onChange}
                                label="Block"
                                name="stage5_block"
                                value={state.stage5_block} 
                                error={state.stage5_block_error}/>
                            <BoxedInput
                                disabled={applicantDetails.residentialAddress.source === '1'}
                                type="text"
                                maxLength="10"
                                onChange={props.onChange}
                                label="Unit"
                                name="stage5_unit"
                                value={state.stage5_unit} 
                                error={state.stage5_unit_error}/>
                        </DoubleWrap>
                        <BoxedInput 
                            disabled={applicantDetails.residentialAddress.source === '1'}
                            type="text"
                            maxLength="66"
                            onChange={props.onChange}
                            label="Street"
                            name="stage5_street"
                            value={state.stage5_street}
                            error={state.stage5_street_error} />
                        <BoxedInput
                            disabled={applicantDetails.residentialAddress.source === '1'}
                            type="text"
                            maxLength="66"
                            onChange={props.onChange}
                            label="Building"
                            name="stage5_building"
                            value={state.stage5_building} 
                            error={state.stage5_building_error}/>
                        <DoubleWrap>
                            <InputWrap>
                                <Label>Country</Label>
                                <BoxedSelect
                                    isDisabled={applicantDetails.residentialAddress.source === '1'}
                                    isSearchable={false}
                                    placeholder="Select"
                                    onChange={props.onReactSelectChange}
                                    name="stage5_country"
                                    menuPlacement="top"
                                    value={state.stage5_country}
                                    options={props.country}/>
                                <Label isValidationMsg >{state.stage5_country_error}</Label>

                            </InputWrap>
                            <BoxedInput 
                                disabled={applicantDetails.residentialAddress.source === '1'}
                                type="text"
                                onChange={props.onChange}
                                onKeyDown={props.onKeyDown}
                                label="Postal Code"
                                name="stage5_postal"
                                value={state.stage5_postal}
                                maxLength="6"
                                error={state.stage5_postal_error} />
                        </DoubleWrap>
                    </FormWrapper>
                    <ButtonWrap>
                        <BackButton onClick={() => props.onBackApplicant()}>
                            Back
                        </BackButton>
                        <Button onClick={() => props.onVerifyContact()}>
                            Next
                        </Button>
                    </ButtonWrap>
                </div>
            </>
        );
    };

export default ContactDetails;
